import React from 'react';
import styles from './IdentityProviderCard.module.css';
import { bigNumberToText } from '../utils';
import notConfiguredIcon from '../common/Images/not_configured.png';

const IdentityProviderCard = ({
    name,
    appsCount,
    appsHeader,
    authsCount,
    policiesCount,
    bridgedAppsCount,
    supportBridge,
    connectorMissConfigured,
    settingsSection
}) => {
    return (
        <div className={styles.card}>
            <div className={styles.name} title={name}>
                <div>{name}</div>
                {connectorMissConfigured && (
                    <a href={`/settings/${settingsSection}`}>
                        <img
                            src={notConfiguredIcon}
                            alt="not configured"
                            title={`Configure ${name} connector to view ${appsHeader || 'application'}s`}
                        />
                    </a>
                )}
            </div>
            <div className={styles.splitter}></div>
            <div
                className={styles.field}
                title={`${bigNumberToText(appsCount)} ${(appsHeader || 'Application') + (appsCount === 1 ? '' : 's')}`}>
                <span className={styles.count}>{bigNumberToText(appsCount)}</span>
                <div>{`${(appsHeader || 'Application') + (appsCount === 1 ? '' : 's')}`}</div>
            </div>
            <div className={styles.field} title={`${bigNumberToText(authsCount)} Authentications`}>
                <span className={styles.count}>{bigNumberToText(authsCount)}</span>
                <div>
                    Authentications<span className={styles.hint}>/30 days</span>
                </div>
            </div>
            {policiesCount >= 0 && (
                <div className={styles.field}>
                    <span className={styles.count}>{policiesCount}</span>
                    <div>Silverfort Policies</div>
                </div>
            )}
            {supportBridge && (
                <div className={styles.field}>
                    <span className={styles.count}>{bridgedAppsCount}</span>
                    <div>Bridged Applications</div>
                </div>
            )}
        </div>
    );
};

export default IdentityProviderCard;
